import { render, staticRenderFns } from "./LinksList.vue?vue&type=template&id=efaf32a2&scoped=true&"
import script from "./LinksList.vue?vue&type=script&lang=js&"
export * from "./LinksList.vue?vue&type=script&lang=js&"
import style0 from "./LinksList.vue?vue&type=style&index=0&id=efaf32a2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efaf32a2",
  null
  
)

export default component.exports